import loadable from '@loadable/component';

import { LoadingPageLoadable } from 'modules/main/pages/Loading';

export const CompensationSurveyLoadable = loadable(
  () =>
    import(
      /* webpackChunkName: "CompensationSurvey" */
      './CompensationSurvey.dynamic'
    ),
  { fallback: <LoadingPageLoadable /> },
);
